export default __webpack_public_path__ + "05cfb8a6e883211c2194cfcb68711422.png";